module.exports = __webpack_public_path__ + "static/img/bushuli3.34c0422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bushuli3.png
// module id = IFqC
// module chunks = 5